export default __webpack_public_path__ + "fde298bbc01e44d034e6eac70c59729f.png";